import { Injectable } from '@angular/core';
import { Educational } from './educational';
import { Experience } from './experience';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class JobService {
  baseUrl = 'https://applyjob.dad.co.th';
  // baseUrl = 'http://applyjob.tsa-autoparts.com';
  //baseUrl = 'http://localhost:65375';

  navigate: number;

  announce: string;
  position: string;

  applyJobID: number;
  firstName: string;
  lastName: string;
  gender: string;
  status: string;
  dateOfBirth: string;
  age: number;
  nationality: string;
  religion: string;
  weight: number;
  height: number;
  tel: number;
  email: string;
  jobPosition: string;

  listEducation: Array<Educational>;
  listExperience: Array<Experience>;

  fileResume: string;
  fileVDO: string;

  LinkUploadVDO :string;

  constructor(private http: Http) {
    this.navigate = 0;

    this.announce = "";
    this.position = "";

    //fix เพื่อทดสอบ
    this.applyJobID = 0;
    this.firstName = "";
    this.lastName = "";
    this.gender = "";
    this.status = "";
    this.dateOfBirth = "";
    this.age = null;
    this.nationality = "";
    this.religion = "";
    this.weight = null;
    this.height = null;
    this.tel = null;
    this.email = "";
    this.jobPosition = "";

    this.listEducation = [];
    this.listExperience = [];

    this.fileResume = "ยังไม่มีไฟล์แนบ";
    this.fileVDO = "ยังไม่มีไฟล์แนบ";

    this.LinkUploadVDO = this.baseUrl + '/Home/RecordVdoIntroduce?applyjobID=' + this.applyJobID;
  }

  public getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : sParameterName[1];
      }
    }
  };

  public NewApplyJobAPI(): Observable<string> {
    let url = this.baseUrl + "/api/ApplyJobApi/NewApplyJob";
    let body = 'ApplyJobID=' + this.applyJobID
      + '&FirstName=' + this.firstName
      + '&LastName=' + this.lastName
      + '&Gender=' + this.gender
      + '&Status=' + this.status
      + '&DateOfBirth=' + this.dateOfBirth
      + '&Age=' + this.age
      + '&Nationality=' + this.nationality
      + '&Religion=' + this.religion
      + '&Weight=' + this.weight
      + '&Height=' + this.height
      + '&Tel=' + this.tel
      + '&Email=' + this.email
      + '&Announce=' + this.announce;
    // + '&JobPosition=' + this.jobPosition
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
    let options = new RequestOptions({ headers: headers });
    return this.http.post(url, body, options)
      .map(response => {
        let apllyJobID = response.json();
        //alert(apllyJobID);
        return apllyJobID;
      });
  }

  public SentMailToApplicant(): Observable<string> {
    let url = this.baseUrl + "/api/Mail/SentMailToApplicant";
    let body = 'ApplyJobID=' + this.applyJobID;
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
    let options = new RequestOptions({ headers: headers });
    return this.http.post(url, body, options)
      .map(response => {
        let apllyJobID = response.json();
        return apllyJobID;
      });
  }

  public SentMailToHumanResource(): Observable<string> {
    let url = this.baseUrl + "/api/Mail/SentMailToHumanResource";
    let body = 'ApplyJobID=' + this.applyJobID;
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
    let options = new RequestOptions({ headers: headers });
    return this.http.post(url, body, options)
      .map(response => {
        let apllyJobID = response.json();
        return apllyJobID;
      });
  }
  
  public GetApplyJobPosition(): Observable<string> {
    //alert("SV : " + this.jobPosition);
    let url = this.baseUrl + "/api/ApplyJobApi/GetApplyJobPosition";
    let body = 'ApplyJobID=' + this.applyJobID
             + '&JobPosition=' + this.jobPosition;
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
    let options = new RequestOptions({ headers: headers });
    return this.http.post(url, body, options)
      .map(response => {
        let positions = response.json();
        return positions;
      });
  }

  public EditPositionApplyJobAPI(): Observable<string> {
    let url = this.baseUrl + "/api/ApplyJobApi/EditApplyJobPosition";
    let body = 'ApplyJobID=' + this.applyJobID
      + '&JobPosition=' + this.jobPosition
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
    let options = new RequestOptions({ headers: headers });
    return this.http.post(url, body, options)
      .map(response => {
        let apllyJobID = response.json();
        return apllyJobID;
      });
  }

  public NewEducationalAPI(): Observable<string> {
    let url = this.baseUrl + "/api/ApplyJobApi/NewEducational";
    let body = this.listEducation;
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    return this.http.post(url, body, options)
      .map(response => {
        let apllyJobID = response.json();
        return apllyJobID;
      });
  }

  public NewExperienceAPI(): Observable<string> {
    let url = this.baseUrl + "/api/ApplyJobApi/NewExperience";
    let body = this.listExperience;
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    return this.http.post(url, body, options)
      .map(response => {
        let apllyJobID = response.json();
        return apllyJobID;
      });
  }

  public Upload(file:File, tag:string): Observable<string> {

    let formData = new FormData();

    formData.append("ApplyJobID", this.applyJobID.toString());
    formData.append("Tag", tag);
    formData.append('file', file);

    console.log(formData);

    let url = this.baseUrl + "/api/Attach/Post";
    return this.http.post(url, formData)
      .map(response => {
        let apllyJobID = response.json();
        return apllyJobID;
      });
  }

  public GetExplanationApplyJobAPI(): Observable<string> {
    let url = this.baseUrl + "/api/ApplyJobApi/GetApplyJobExplanation";
    let body = 'PositionID=0' + '&PositionName=' + this.jobPosition
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
    let options = new RequestOptions({ headers: headers });
    return this.http.post(url, body, options)
      .map(response => {
        let explanation = response.json();
        return explanation;
      });
  }

  public CheckUrlResume(): Observable<string> {
    let url = this.baseUrl + "/api/ApplyJobAdminManageApi/CheckUrlResume";
    let body = 'ApplyJobID=' + this.applyJobID;

    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
    let options = new RequestOptions({ headers: headers });
    return this.http.post(url, body, options)
      .map(response => {
        let result = response.json();
        return result;
      });
  }

  public CheckUrlVDO(): Observable<string> {
    let url = this.baseUrl + "/api/ApplyJobAdminManageApi/CheckUrlVDO";
    let body = 'ApplyJobID=' + this.applyJobID;

    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
    let options = new RequestOptions({ headers: headers });
    return this.http.post(url, body, options)
      .map(response => {
        let result = response.json();
        return result;
      });
  }

  public ClearData() {
    this.navigate = 0;

    //this.announce = "";
    //this.position = "";

    this.applyJobID = 0;
    this.firstName = "";
    this.lastName = "";
    this.gender = "";
    this.status = "";
    this.dateOfBirth = "";
    this.age = null;
    this.nationality = "";
    this.religion = "";
    this.weight = null;
    this.height = null;
    this.tel = null;
    this.email = "";
    this.jobPosition = "";

    this.listEducation = [];
    this.listExperience = [];
  }
}



// WEBPACK FOOTER //
// ./src/app/jobService.ts